import { Typography } from '@/components/atoms';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ListingEmptyBuildingsIcon } from './ListingEmptyBuildingsIcon';

export interface ListingEmptyStateProps {
  title: string;
  subtitle: string;
}

/**
 * Centered empty / error panel for the ADHA properties listing (web).
 * Same illustration for no units, price-filter miss, and fetch failure.
 */
export function ListingEmptyState({
  title,
  subtitle,
}: Readonly<ListingEmptyStateProps>) {
  return (
    <View style={styles.container}>
      <ListingEmptyBuildingsIcon />
      <View style={styles.copy}>
        <Typography
          variant="title2"
          color="fontHighContrast"
          style={styles.title}
        >
          {title}
        </Typography>
        <Typography variant="body" color="fontMuted" style={styles.subtitle}>
          {subtitle}
        </Typography>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 64,
    paddingHorizontal: 24,
    gap: 24,
  },
  copy: {
    alignItems: 'center',
    gap: 8,
    width: '100%',
    maxWidth: 420,
  },
  title: {
    width: '100%',
    textAlign: 'center',
    lineHeight: 22,
    fontFamily: 'Matter-SemiBold',
  },
  subtitle: {
    width: '100%',
    textAlign: 'center',
    lineHeight: 22,
  },
});

export default ListingEmptyState;
